export default "__VITE_ASSET__y3WuTrdTs_Si7uYpRddj9w__ 220w";